/* GiftInOne Editor 2.14.17: optional mobile text-input presentation.
 * Original fields, input/composition events and order validation stay intact.
 * Every entry point fails back to the existing editor; no cart/request hooks.
 */
(function () {
  'use strict';
  if (window.GIOEditorV2MobileInput) return;
  var media = '(max-width:760px), (max-width:1024px) and (pointer:coarse) and (orientation:landscape)';
  var classes = ['gio-mobile-input-active', 'gio-mobile-input-no-preview', 'gio-mobile-input-tiny'];
  function noop() {}
  window.GIOEditorV2MobileInput = {bind: function (options) {
    options = options || {};
    var main = options.main, side = options.side, content = options.content;
    var active = null, toolbar = null, done = null, title = null, field = null, counter = null;
    var paths = [], scrolls = [], removers = [], observer = null, visibilityObserver = null;
    var disposed = false, failed = false, composing = false, finishing = false, queued = 0, blurTimer = 0, finishTimer = 0, reboundTimer = 0;
    var restoreState = null, baseline = 0, minimum = 0, keyboardSeen = false, enteredAt = 0, idleHeight = 0, enteredWidth = 0;
    var viewport = window.visualViewport;
    var api = {finish: function () { guarded(requestFinish); }, destroy: destroy};

    function attempt(fn) { try { fn(); } catch (error) {} }
    function eligible(el) {
      if (!el || el.nodeType !== 1 || !side.contains(el) || el.disabled || el.readOnly) return false;
      if (el.tagName === 'TEXTAREA') return true;
      // Do not turn photo sliders, colors, variants, quantities or file pickers
      // into text mode merely because they receive focus.
      return el.tagName === 'INPUT' && /^(text|search|email|url|tel|password)$/.test(el.type || 'text');
    }
    function mobile() { return !!(window.matchMedia && window.matchMedia(media).matches); }
    function visible() { return main.isConnected && main.classList.contains('tingle-modal--visible'); }
    function ready() {
      return mobile() && window.getComputedStyle(main).getPropertyValue('--gio-mobile-input-ready').trim() === '1';
    }
    function height() {
      var value = viewport && viewport.height;
      var reserved = parseFloat(window.getComputedStyle(main).getPropertyValue('--gio-visible-height'));
      if (reserved > 0) value = value > 0 ? Math.min(value, reserved) : reserved;
      return Math.max(0, value || window.innerHeight || main.clientHeight || 0);
    }
    function width() { return window.innerWidth || document.documentElement.clientWidth || 0; }
    function on(el, name, fn, capture) {
      var callback = function (event) { guarded(function () { fn(event); }); };
      el.addEventListener(name, callback, capture || false);
      removers.push(function () { el.removeEventListener(name, callback, capture || false); });
    }
    function guarded(fn) {
      if (disposed || failed) return;
      try { return fn(); }
      catch (error) { fail(); }
    }
    function cancelTimers() {
      if (queued) attempt(function () { window.cancelAnimationFrame(queued); });
      attempt(function () { window.clearTimeout(blurTimer); });
      attempt(function () { window.clearTimeout(finishTimer); });
      attempt(function () { window.clearTimeout(reboundTimer); });
      queued = 0; blurTimer = 0; finishTimer = 0; reboundTimer = 0;
    }
    function leave(restore) {
      var previous = active, state = restoreState, saved = scrolls.slice();
      var focusWasInToolbar = false;
      attempt(function () { focusWasInToolbar = toolbar && toolbar.contains(document.activeElement); });
      // Clearing the root class first immediately reveals all normal controls,
      // even if an observer or third-party DOM change broke later cleanup.
      classes.forEach(function (name) { attempt(function () { main.classList.remove(name); }); });
      attempt(function () { main.style.removeProperty('--gio-mobile-input-preview-height'); });
      attempt(function () { if (toolbar) toolbar.hidden = true; });
      attempt(function () { if (field) field.classList.remove('gio-mobile-input-field'); });
      attempt(function () { if (previous) previous.classList.remove('gio-mobile-input-control'); });
      paths.forEach(function (el) { attempt(function () { el.classList.remove('gio-mobile-input-path'); }); });
      attempt(function () { if (counter && counter.parentNode) counter.parentNode.removeChild(counter); });
      active = null; field = null; counter = null; paths = []; scrolls = [];
      restoreState = null; composing = false; finishing = false; keyboardSeen = false;
      cancelTimers();
      // These calls can only restore presentation. Neither touches disabled
      // state, form values, source files, scenes, or the selected template.
      if (restore && state != null && typeof options.setDrawerState === 'function') attempt(function () { options.setDrawerState(state, false); });
      saved.forEach(function (item) { attempt(function () { item.el.scrollTop = item.top; item.el.scrollLeft = item.left; }); });
      if (restore && focusWasInToolbar) attempt(function () {
        var tab = side.querySelector('.gio-editor-v2-tab[aria-selected="true"]');
        if (tab && visible() && !tab.disabled) tab.focus({preventScroll: true});
      });
      attempt(function () { idleHeight = height(); });
    }
    function fail() {
      if (failed) return;
      failed = true;
      attempt(function () { leave(true); });
      removers.splice(0).forEach(function (remove) { attempt(remove); });
      attempt(function () { if (observer) observer.disconnect(); });
      attempt(function () { if (visibilityObserver) visibilityObserver.disconnect(); });
      attempt(function () { if (toolbar && toolbar.parentNode) toolbar.parentNode.removeChild(toolbar); });
    }
    function destroy() {
      if (disposed) return;
      attempt(function () { leave(false); }); disposed = true;
      removers.splice(0).forEach(function (remove) { attempt(remove); });
      attempt(function () { if (observer) observer.disconnect(); });
      attempt(function () { if (visibilityObserver) visibilityObserver.disconnect(); });
      attempt(function () { if (toolbar && toolbar.parentNode) toolbar.parentNode.removeChild(toolbar); });
    }
    function updateCounter() {
      if (!active || !counter) return;
      var value = String(active.value || ''), size = Array.from(value).length;
      var limit = Number(active.getAttribute('data-max-codepoints') || active.getAttribute('maxlength'));
      if (!limit && (active.getAttribute('data-control') === 'message' || active.getAttribute('data-template-control') === 'free-message')) limit = 160;
      var text = limit > 0 ? size + ' / ' + limit : size + ' characters';
      if (counter.textContent !== text) counter.textContent = text;
    }
    function layout() {
      if (!active) { idleHeight = height(); return; }
      if (!visible() || !active.isConnected || !side.contains(active)) {
        leave(true); return;
      }
      if (!ready()) { requestFinish(); return; }
      var available = height();
      if (enteredWidth && Math.abs(width() - enteredWidth) > 80) {
        // Rotation is not keyboard dismissal. Keep the real focused field in
        // its usable input layout and establish a new viewport baseline.
        baseline = available; minimum = available; keyboardSeen = false;
        enteredWidth = width(); enteredAt = Date.now();
      }
      var previewHeight = available >= 420 ? 100 : available >= 360 ? 80 : 0;
      var value = previewHeight + 'px';
      if (main.style.getPropertyValue('--gio-mobile-input-preview-height') !== value) main.style.setProperty('--gio-mobile-input-preview-height', value);
      main.classList.toggle('gio-mobile-input-no-preview', previewHeight === 0);
      main.classList.toggle('gio-mobile-input-tiny', available < 220);
      minimum = Math.min(minimum || available, available);
      // A viewport can also shrink during page zoom. Only a normal-scale,
      // substantial shrink followed by a rebound identifies keyboard dismissal.
      if (!viewport || !viewport.scale || Math.abs(viewport.scale - 1) < .05) {
        if (baseline - available > 120) keyboardSeen = true;
        if (keyboardSeen && available - minimum > 100 && available >= baseline - 70 && Date.now() - enteredAt > 500) {
          if (!reboundTimer) reboundTimer = window.setTimeout(function () {
            reboundTimer = 0;
            guarded(function () { if (active && height() >= baseline - 70) requestFinish(); });
          }, 180);
        } else { window.clearTimeout(reboundTimer); reboundTimer = 0; }
      }
    }
    function queue() {
      if (queued || disposed || failed) return;
      queued = window.requestAnimationFrame(function () { queued = 0; guarded(layout); });
    }
    function enter(input) {
      if (!eligible(input) || !visible() || !ready()) return;
      if (input === active) return;
      if (active) leave(true);
      var leaf = input.closest('.gio-design-field, .gio-template-field, .line-item-property__field, label');
      if (!leaf || !side.contains(leaf) || leaf.querySelectorAll('textarea,input:not([type="hidden"])').length !== 1) leaf = input;
      var parent = leaf.parentElement, chain = [];
      while (parent && side.contains(parent)) {
        chain.push(parent); if (parent === side) break; parent = parent.parentElement;
      }
      if (!chain.length || chain[chain.length - 1] !== side) return;
      restoreState = typeof options.getDrawerState === 'function' ? options.getDrawerState() : null;
      active = input; field = leaf; paths = chain;
      scrolls = chain.map(function (el) { return {el: el, top: el.scrollTop, left: el.scrollLeft}; });
      baseline = Math.max(idleHeight, height()); minimum = height(); enteredAt = Date.now(); enteredWidth = width(); keyboardSeen = false;
      title.textContent = 'Edit message'; toolbar.hidden = false;
      paths.forEach(function (el) { el.classList.add('gio-mobile-input-path'); });
      field.classList.add('gio-mobile-input-field'); input.classList.add('gio-mobile-input-control');
      // Template inputs already have live, engine-owned counters. Ordinary
      // text uses a presentation-only counter, with no validation side effects.
      if (leaf !== input && !leaf.querySelector('.gio-template-character-count, .gio-template-free-count')) {
        counter = document.createElement('span'); counter.className = 'gio-mobile-input-count';
        leaf.appendChild(counter); updateCounter();
      }
      main.classList.add('gio-mobile-input-active');
      // Short-screen drawer mode may have hidden the preview. Let the drawer
      // yield its geometry now; input mode independently chooses 0/80/100 px.
      main.classList.remove('gio-tools-preview-hidden');
      if (restoreState != null && typeof options.setDrawerState === 'function') attempt(function () { options.setDrawerState(restoreState, false); });
      paths.forEach(function (el) { el.scrollTop = 0; });
      layout(); queue();
    }
    function requestFinish() {
      if (!active) return;
      finishing = true;
      var input = active;
      // Native blur commits the active IME in browsers. Do not manufacture
      // input/change/composition events or rewrite value/caret/selection.
      if (document.activeElement === input) input.blur();
      if (composing) {
        // A disconnected input may never emit compositionend. Still reveal the
        // original editor after a short grace period instead of trapping users.
        window.clearTimeout(finishTimer);
        finishTimer = window.setTimeout(function () { guarded(function () { leave(true); }); }, 350);
      } else leave(true);
    }
    function focusOut() {
      window.clearTimeout(blurTimer);
      blurTimer = window.setTimeout(function () {
        blurTimer = 0;
        guarded(function () {
          if (!active || document.activeElement === active || (toolbar && toolbar.contains(document.activeElement))) return;
          if (eligible(document.activeElement)) enter(document.activeElement);
          else requestFinish();
        });
      }, 0);
    }
    try {
      if (!main || !side || !content || !main.classList || !side.contains || !content.insertBefore) return {finish: noop, destroy: noop};
      toolbar = document.createElement('div'); toolbar.className = 'gio-mobile-input-bar'; toolbar.hidden = true;
      title = document.createElement('strong'); title.className = 'gio-mobile-input-title'; title.textContent = 'Edit message';
      done = document.createElement('button'); done.className = 'gio-mobile-input-done'; done.type = 'button'; done.textContent = 'Done';
      done.setAttribute('aria-label', 'Finish editing this message');
      toolbar.appendChild(title); toolbar.appendChild(done); content.insertBefore(toolbar, content.firstChild);
      on(side, 'focusin', function (event) { enter(event.target); });
      on(side, 'focusout', focusOut);
      on(side, 'input', function (event) { if (event.target === active) updateCounter(); });
      on(side, 'compositionstart', function (event) { if (event.target === active) composing = true; });
      on(side, 'compositionend', function (event) {
        if (event.target !== active) return;
        composing = false; updateCounter();
        // The engine's own compositionend listener runs normally before exit.
        if (finishing) { window.clearTimeout(finishTimer); finishTimer = window.setTimeout(function () { guarded(function () { leave(true); }); }, 0); }
      });
      on(done, 'click', requestFinish);
      on(toolbar, 'focusout', focusOut);
      on(window, 'resize', queue);
      on(window, 'orientationchange', function () {
        if (active) { baseline = height(); minimum = baseline; keyboardSeen = false; enteredWidth = width(); enteredAt = Date.now(); }
        queue();
      });
      if (viewport) { on(viewport, 'resize', queue); on(viewport, 'scroll', queue); }
      if (window.MutationObserver) {
        observer = new MutationObserver(function () { guarded(function () {
          if (active && (!active.isConnected || !side.contains(active) || field.hidden || paths.some(function (el) { return el.hidden || !el.contains(active); }))) leave(true);
        }); });
        observer.observe(side, {childList: true, subtree: true, attributes: true, attributeFilter: ['hidden']});
        visibilityObserver = new MutationObserver(function () { guarded(function () {
          if (active && !visible()) leave(true);
          else if (active) queue();
        }); });
        visibilityObserver.observe(main, {attributes: true, attributeFilter: ['class', 'style']});
      }
      idleHeight = height();
      if (eligible(document.activeElement)) enter(document.activeElement);
      return api;
    } catch (error) {
      fail(); return {finish: noop, destroy: destroy};
    }
  }};
}());
